import React, { useState, useEffect } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import { useNavigate } from "react-router-dom";
import "../../styles/App.css";
import { NO_GROUP_TEXT } from "../../components/GroupLabel.js";

const ReviewActs = () => {
  const [proposedActs, setProposedActs] = useState([]);
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_BASE;


  useEffect(() => {
    fetch(`${API}/api/proposed-acts`, {
      headers: { Authorization: getAuthHeader() },
    })
      .then((res) => res.json())
      .then((data) => setProposedActs(data))
      .catch((error) => console.error("Помилка завантаження актів:", error));
  }, []);

  const handleDecision = async (id, action) => {
    try {
      const response = await fetch(`${API}/api/review-act/${id}`, {
        method: "POST",
        headers: { Authorization: getAuthHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ action }),
      });
      const data = await response.json();
      alert(data.message);
      setProposedActs(proposedActs.filter((act) => act.id !== id));
    } catch (error) {
      console.error("Помилка ухвалення рішення:", error);
    }
  };

  // Обробка кліку на рядок
  const handleRowClick = (studentId) => {
    navigate(`/student/${studentId}`); // Перехід на сторінку студента
  };

  return (
    <div className="page-container">
      <h2 className="header-content-title">Розгляд запропонованих актів</h2>
      {proposedActs.length > 0 ? (
        <table className="table">
          <thead>
            <tr>
              <th className="table-header">Дата</th>
              <th className="table-header">ПІБ студента та група</th>
              <th className="table-header">Опис</th>
              <th className="table-header">Файл</th>
              <th className="table-header">Дія</th>
            </tr>
          </thead>
          <tbody>
            {proposedActs.map((act) => (
              <tr key={act.id}>
                <td className="table-content">
                  {new Date(act.date).toLocaleDateString()}
                </td>
                <td
                  className="table-content"
                  onClick={() => handleRowClick(act.student_id)}
                  style={{ cursor: "pointer" }}
                >
                  {act.pib} ({act.group || NO_GROUP_TEXT})
                </td>
                <td className="table-content">{act.reason}</td>
                <td className="table-content">
                  {act.file_url ? (
                    <a
                      href={act.file_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Переглянути
                    </a>
                  ) : (
                    "Немає файлу"
                  )}
                </td>
                <td className="table-content">
                  <button
                    className="restore-button"
                    onClick={() => handleDecision(act.id, "act")}
                  >
                    Виписати акт
                  </button>
                  <button
                    className="restore-button"
                    onClick={() => handleDecision(act.id, "warning")}
                  >
                    Виписати попередження
                  </button>
                  <button
                    className="remove-button"
                    onClick={() => handleDecision(act.id, "reject")}
                  >
                    Відхилити
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <h2 className="no-data">В даний час немає даних.</h2>
      )}
    </div>
  );
};

export default ReviewActs;
